import { DecoratedFormProps, InjectedFormProps, reduxForm } from 'redux-form';
import { FormError } from 'src/components/redux-form/FormError';
import React, { useState } from 'react';
import {
    emailList,
    maxLength,
    minLength,
    minPhoneLength,
    required,
    Validators,
} from 'src/components/redux-form/utils/validators';
import classNames from 'classnames';
import { FieldInput } from 'src/components/redux-form/fields/FieldInput';
import styles from '../assets/password-recovery-screen.module.scss';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dispatch } from 'redux';
import { toast } from 'react-toastify';
import { FieldDate } from '../../../../../components/redux-form/fields/FieldDate';
import {
    asyncPersistIntakeNeuropsychologyPatient,
    asyncPersistIntakeOfficePolicies,
} from '../../../../../store/actions/intakeSent-actions';
import { push } from 'connected-react-router';
import Router from '../../../../../navigation/router';
import { routes } from '../../../../../navigation';
import { FieldSelectList } from '../../../../../components/redux-form/fields/FieldSelectList';
import { FieldTextArea } from '../../../../../components/redux-form/fields/FieldTextArea';

export interface NeuropsychologyPatientFormData {
    student: string;
    formId: string;

    childName: string;
    childDob: string;
    childHeight: string;
    childHanded: string;
    childFeatured: string;
    ethnicity: string;
    gradeSchool: string;
    nameOfSchool: string;
    haveIep: string;

    parentFirstName: string;
    parentFirstDob: string;
    parentFirstHomePhone: string;
    parentFirstHome: string;
    parentFirstCell: string;
    parentFirstWorkPhone: string;
    parentFirstEmail: string;
    parentFirstAddress: string;
    parentFirstHighLevelOfEdu: string;
    parentFirstPlaceOfEmployment: string;
    parentFirstPositionAtWork: string;
    parentFirstIsCall: string;
    parentFirstCallHours: string;

    parentSecondName: string;
    parentSecondDob: string;
    parentSecondHomePhone: string;
    parentSecondHome: string;
    parentSecondCell: string;
    parentSecondWorkPhone: string;
    parentSecondEmail: string;
    parentSecondAddress: string;
    parentSecondHighLevelOfEdu: string;
    parentSecondPlaceOfEmployment: string;
    parentSecondPositionAtWork: string;
    parentSecondIsCall: string;
    parentSecondCallHours: string;

    refForEval: string;
    concernsAboutChild: string;
    causingProblems: string;
    problemsEvaluate: string;
    stepsDealWithConcern: string;
    childStrengths: string;
    hasBeenEvaluated: string;
    emailPdf: string;
    evalOrTreatment: string;
    childStrengthsTwo: string;

    bioChild: string;
    motherAge: string;
    fatherAge: string;
    numOfPreg: string;
    twinOrNotPreg: string;
    complicationsPreg: string;
    motherMiscarriages: string;
    conditionsRelatedPreg: [];
    conditionRelatedPregOther: string;
    motherDuringPreg: [];
    deliveryDifficult: string;
    byCesareanSection: string;
    laborLast: string;
    nicuWas: string;
    fullTerm: string;
    hospitalBorn: string;
    childSeizures: string;
    childInfection: string;
    childDefects: string;
    childColic: string;
    childAnyProblem: string;

    sitAge: string;
    walkAlone: string;
    jumpRun: string;
    rideTwoWheelBike: string;
    useSpoon: string;
    dressSelf: string;
    catchBall: string;
    firstWords: string;
    putTwoWordsTogether: string;
    twoWordsSentence: string;
    tieShoelaces: string;
    achieveDaytimeDryness: string;
    separateFromParents: string;
    toiletTrained: string;

    primaryPhysician: string;
    everHospitalized: string;
    currentMedications: string;
    haveAllergies: string;
    immunizations: string;
    headInjuries: string;
    everHadAny: [];
    everHadAnyOther: string;
    everHadAnyAdditional: string;
    hadEeg: string;

    seenCounselor: string;
    provideDates: string;
    mentalProfessional: string;
    psychiatricHospital?: string;
    datesHospital: string;
    takenPsychMeds: string;
    provideMeds: string;
    selfHarm: string;

    putBedSchool: string;
    putBedNoSchool: string;
    wakeUpSchool: string;
    wakeUpNoSchool: string;
    sleepProblems: [];
    sleepProblemsOther: string;

    relativesList: string;
    immediateFamilyMembersList: string;
    areDivorced: string;
    motherLegalCustody: string;
    motherPhysicalCustody: string;
    fatherLegalCustody: string;
    fatherPhysicalCustody: string;
    parentsCustody: string;
    residingAnotherHome: string;
    spokenLang: string;
    spokenLangTwo: string;
    parentPrimaryLang: string;
    parentSecondaryLang: string;
    relatedProblems: [];

    historyOfAnyFollowing: string;
    psychologicalProblems: [];

    medicalProblems: [];
    indicateRelation: string;

    childAloneMother: string;
    childAloneFather: string;
    childAloneSibling: string;
    childAloneOtherRel: string;
    childAloneWithBoys: string;
    childAloneWithGirls: string;
    childAloneWithYounger: string;
    childAloneWithAdult: string;
    temperament: string;
    manageDiscipline: string;
    methodDiscipline: string;
    behaviorsDisplay: [];
    behaviorsDisplayOther: string;
    behaviorsConcernToYou: [];
    behaviorsConcernToYouOther: string;

    schoolInfo: string;
    schoolName: string;
    schoolLocation: string;
    gradeOfChild: string;
    teacher: string;
    childHaveIep: string;
    havePlan: string;
    doingInSchool: string;
    concernSchoolYear: string;
    receivedServices: [];
    receivedServicesOther: string;
    receivedServicesAdditional: string;
    curTeacher: string;
    homework: string;
    farSchool: string;
    otherInfo: string;

    completedBy: string;
    relationToChild: string;
    signPerson: string;
    completedDate: string;
}

interface NeuropsychologyPatientFormProps {
    initialValues: any;
    setIsLoader: any;
}

type InjectedProps = InjectedFormProps<NeuropsychologyPatientFormData, NeuropsychologyPatientFormProps>;

const validators: Validators<NeuropsychologyPatientFormData> = {
    childName: [required({ message: "It's required." })],
    childDob: [required({ message: "It's required." })],
    childHeight: [required({ message: "It's required." })],
    childHanded: [required({ message: "It's required." })],
    childFeatured: [required({ message: "It's required." })],
    ethnicity: [required({ message: "It's required." })],
    gradeSchool: [required({ message: "It's required." })],
    nameOfSchool: [required({ message: "It's required." })],
    haveIep: [required({ message: "It's required." })],

    parentFirstName: [required({ message: "It's required." })],
    parentFirstDob: [required({ message: "It's required." })],
    parentFirstHomePhone: [required({ message: "It's required." })],
    parentFirstHome: [required({ message: "It's required." })],
    parentFirstCell: [required({ message: "It's required." })],
    parentFirstWorkPhone: [required({ message: "It's required." })],
    parentFirstEmail: [required({ message: "It's required." })],
    parentFirstAddress: [required({ message: "It's required." })],
    parentFirstHighLevelOfEdu: [required({ message: "It's required." })],
    parentFirstPlaceOfEmployment: [required({ message: "It's required." })],
    parentFirstPositionAtWork: [required({ message: "It's required." })],
    parentFirstIsCall: [required({ message: "It's required." })],
    parentFirstCallHours: [required({ message: "It's required." })],

    parentSecondName: [required({ message: "It's required." })],
    parentSecondDob: [required({ message: "It's required." })],
    parentSecondHomePhone: [required({ message: "It's required." })],
    parentSecondHome: [required({ message: "It's required." })],
    parentSecondCell: [required({ message: "It's required." })],
    parentSecondWorkPhone: [required({ message: "It's required." })],
    parentSecondEmail: [required({ message: "It's required." })],
    parentSecondAddress: [required({ message: "It's required." })],
    parentSecondHighLevelOfEdu: [required({ message: "It's required." })],
    parentSecondPlaceOfEmployment: [required({ message: "It's required." })],
    parentSecondPositionAtWork: [required({ message: "It's required." })],
    parentSecondIsCall: [required({ message: "It's required." })],
    parentSecondCallHours: [required({ message: "It's required." })],

    refForEval: [required({ message: "It's required." })],
    concernsAboutChild: [required({ message: "It's required." })],
    causingProblems: [required({ message: "It's required." })],
    problemsEvaluate: [required({ message: "It's required." })],
    stepsDealWithConcern: [required({ message: "It's required." })],
    childStrengths: [required({ message: "It's required." })],
    hasBeenEvaluated: [required({ message: "It's required." })],
    emailPdf: [required({ message: "It's required." })],
    evalOrTreatment: [required({ message: "It's required." })],
    childStrengthsTwo: [required({ message: "It's required." })],

    bioChild: [required({ message: "It's required." })],
    motherAge: [required({ message: "It's required." })],
    fatherAge: [required({ message: "It's required." })],
    numOfPreg: [required({ message: "It's required." })],
    twinOrNotPreg: [required({ message: "It's required." })],
    complicationsPreg: [required({ message: "It's required." })],
    motherMiscarriages: [required({ message: "It's required." })],
    deliveryDifficult: [required({ message: "It's required." })],
    byCesareanSection: [required({ message: "It's required." })],
    laborLast: [required({ message: "It's required." })],
    nicuWas: [required({ message: "It's required." })],
    fullTerm: [required({ message: "It's required." })],
    hospitalBorn: [required({ message: "It's required." })],
    childSeizures: [required({ message: "It's required." })],
    childInfection: [required({ message: "It's required." })],
    childDefects: [required({ message: "It's required." })],
    childColic: [required({ message: "It's required." })],
    childAnyProblem: [required({ message: "It's required." })],

    sitAge: [required({ message: "It's required." })],
    walkAlone: [required({ message: "It's required." })],
    jumpRun: [required({ message: "It's required." })],
    rideTwoWheelBike: [required({ message: "It's required." })],
    useSpoon: [required({ message: "It's required." })],
    dressSelf: [required({ message: "It's required." })],
    catchBall: [required({ message: "It's required." })],
    firstWords: [required({ message: "It's required." })],
    putTwoWordsTogether: [required({ message: "It's required." })],
    twoWordsSentence: [required({ message: "It's required." })],
    tieShoelaces: [required({ message: "It's required." })],
    achieveDaytimeDryness: [required({ message: "It's required." })],
    separateFromParents: [required({ message: "It's required." })],
    toiletTrained: [required({ message: "It's required." })],

    primaryPhysician: [required({ message: "It's required." })],
    everHospitalized: [required({ message: "It's required." })],
    currentMedications: [required({ message: "It's required." })],
    haveAllergies: [required({ message: "It's required." })],
    immunizations: [required({ message: "It's required." })],
    headInjuries: [required({ message: "It's required." })],
    hadEeg: [required({ message: "It's required." })],

    seenCounselor: [required({ message: "It's required." })],
    mentalProfessional: [required({ message: "It's required." })],
    psychiatricHospital: [required({ message: "It's required." })],
    takenPsychMeds: [required({ message: "It's required." })],
    selfHarm: [required({ message: "It's required." })],

    putBedSchool: [required({ message: "It's required." })],
    putBedNoSchool: [required({ message: "It's required." })],
    wakeUpSchool: [required({ message: "It's required." })],
    wakeUpNoSchool: [required({ message: "It's required." })],

    relativesList: [required({ message: "It's required." })],
    immediateFamilyMembersList: [required({ message: "It's required." })],
    areDivorced: [required({ message: "It's required." })],
    motherLegalCustody: [required({ message: "It's required." })],
    motherPhysicalCustody: [required({ message: "It's required." })],
    fatherLegalCustody: [required({ message: "It's required." })],
    fatherPhysicalCustody: [required({ message: "It's required." })],
    parentsCustody: [required({ message: "It's required." })],
    residingAnotherHome: [required({ message: "It's required." })],
    spokenLang: [required({ message: "It's required." })],
    spokenLangTwo: [required({ message: "It's required." })],
    parentPrimaryLang: [required({ message: "It's required." })],
    parentSecondaryLang: [required({ message: "It's required." })],

    historyOfAnyFollowing: [required({ message: "It's required." })],

    indicateRelation: [required({ message: "It's required." })],

    childAloneMother: [required({ message: "It's required." })],
    childAloneFather: [required({ message: "It's required." })],
    childAloneSibling: [required({ message: "It's required." })],
    childAloneOtherRel: [required({ message: "It's required." })],
    childAloneWithBoys: [required({ message: "It's required." })],
    childAloneWithGirls: [required({ message: "It's required." })],
    childAloneWithYounger: [required({ message: "It's required." })],
    childAloneWithAdult: [required({ message: "It's required." })],
    temperament: [required({ message: "It's required." })],
    manageDiscipline: [required({ message: "It's required." })],
    methodDiscipline: [required({ message: "It's required." })],

    schoolInfo: [required({ message: "It's required." })],
    schoolName: [required({ message: "It's required." })],
    schoolLocation: [required({ message: "It's required." })],
    gradeOfChild: [required({ message: "It's required." })],
    teacher: [required({ message: "It's required." })],
    childHaveIep: [required({ message: "It's required." })],
    havePlan: [required({ message: "It's required." })],
    doingInSchool: [required({ message: "It's required." })],
    concernSchoolYear: [required({ message: "It's required." })],
    curTeacher: [required({ message: "It's required." })],
    homework: [required({ message: "It's required." })],
    farSchool: [required({ message: "It's required." })],

    completedBy: [required({ message: "It's required." })],
    relationToChild: [required({ message: "It's required." })],
    signPerson: [required({ message: "It's required." })],
    completedDate: [required({ message: "It's required." })],
};

const NeuropsychologyPatientForm: React.FunctionComponent<InjectedProps & NeuropsychologyPatientFormProps> = ({
    handleSubmit,
    error,
    dirty,
    submitting,
    initialValues,
    setIsLoader,
}: InjectedProps & NeuropsychologyPatientFormProps) => {
    const yesNoValues: SelectObject[] = [
        { label: 'Yes', value: 1 },
        { label: 'No', value: 2 },
    ];
    const bioValues: SelectObject[] = [
        { label: 'Biological', value: 1 },
        { label: 'Adopted', value: 2 },
    ];
    const numPregValues: SelectObject[] = [
        { label: 'First', value: 1 },
        { label: 'Second', value: 2 },
        { label: 'Third', value: 3 },
        { label: 'Fourth', value: 4 },
        { label: 'Fifth+', value: 5 },
    ];
    const conditionsRelatedPregValues: SelectObject[] = [
        { label: 'Child exposed to smoke, alcohol, drugs, other toxins?', value: 1 },
        { label: 'Mother experienced frequent vomiting', value: 2 },
        { label: 'Mother experienced bleeding in the first trimester (months 1-3)', value: 3 },
        { label: 'Mother experienced bleeding in the second trimester (months 4-6)', value: 4 },
        { label: 'Mother experienced bleeding in the third trimester (months 7-9)', value: 5 },
        { label: 'Mother experienced increased blood pressure', value: 6 },
        { label: 'Mother had infection during pregnancy', value: 7 },
        { label: 'Medication was prescribed during pregnancy', value: 8 },
    ];
    const motherDuringPregValues: SelectObject[] = [
        { label: 'Was labor induced?', value: 1 },
        { label: 'Had trouble breathing at birth', value: 2 },
        { label: 'Born with umbilical cord wrapped around neck', value: 3 },
        { label: 'Required oxygen at birth', value: 4 },
        { label: 'Child experienced jaundice', value: 5 },
        { label: 'Child experienced phototherapy', value: 6 },
        { label: 'Had trouble sucking and feeding', value: 7 },
    ];

    const yesNoOtherValues: SelectObject[] = [
        { label: 'Yes', value: 1 },
        { label: 'No', value: 2 },
        { label: 'Other', value: 3 },
    ];

    const everHadAnyValues: SelectObject[] = [
        { label: 'Ear infections', value: 1 },
        { label: 'Hearing problems', value: 2 },
        { label: 'Tubes in ears', value: 3 },
        { label: 'Vision problems', value: 4 },
        { label: 'Date of last vision exam', value: 5 },
        { label: 'Does the child wear glasses?', value: 6 },
        { label: 'High lead level', value: 7 },
        { label: 'Anemia', value: 8 },
        { label: 'Asthma', value: 9 },
        { label: 'Slow weight gain', value: 10 },
        { label: 'Excessive weight gain', value: 11 },
        { label: 'Anorexia', value: 12 },
        { label: 'Bulimia', value: 13 },
        { label: 'Urinary problems', value: 14 },
        { label: 'Bowel problems', value: 15 },
        { label: 'Heart problems', value: 16 },
        { label: 'High fever (>103)', value: 17 },
        { label: 'Seizures', value: 18 },
        { label: 'Loss of consciousness', value: 19 },
        { label: 'Headaches', value: 20 },
        { label: 'Meningitis/Encephalitis', value: 21 },
        { label: 'Strep Throat', value: 22 },
        { label: 'Tick bite/Lyme Disease', value: 23 },
        { label: 'Broken Bones', value: 24 },
        { label: 'Other', value: 25 },
    ];

    const sleepProblemsValues: SelectObject[] = [
        { label: 'has difficulty falling asleep', value: 1 },
        { label: 'wakes up during the night (1-3 times)', value: 2 },
        { label: 'wakes up during the night (4+ times)', value: 3 },
        { label: 'snores', value: 4 },
        { label: 'nightmares', value: 5 },
        { label: 'restless sleeper (tosses and turns)', value: 6 },
        { label: 'night terrors', value: 7 },
        { label: 'is an early riser', value: 8 },
        { label: 'is hard to wake up in the morning', value: 9 },
        { label: 'other', value: 10 },
    ];

    const hasProceduresValues: SelectObject[] = [
        { label: 'Hearing', value: 1 },
        { label: 'Vision', value: 2 },
        { label: 'EEG', value: 3 },
        { label: 'CT Scan', value: 4 },
        { label: 'Brain MRI', value: 5 },
        { label: 'Other', value: 6 },
    ];

    const relatedProblemsValues: SelectObject[] = [
        { label: 'Separation', value: 1 },
        { label: 'Divorce', value: 2 },
        { label: 'Change of school', value: 3 },
        { label: 'Change of residence', value: 4 },
        { label: 'Addition to the family', value: 5 },
        { label: 'Legal problems', value: 6 },
        { label: 'Illness of family member', value: 7 },
        { label: 'Financial stress', value: 8 },
        { label: 'Parental loss/change of job', value: 9 },
        { label: 'Incarceration of a parent (at any time in the past)', value: 10 },
        { label: 'Domestic violence between parents/caregivers (at any time in the past)', value: 11 },
        { label: 'Substance (drugs or alcohol) abuse by a parent (at any time in the past)', value: 12 },
    ];

    const psychologicalProblemsValues: SelectObject[] = [
        { label: 'Hyperactivity', value: 1 },
        { label: 'Attention Problems/ADHD', value: 2 },
        { label: 'Reading Difficulties', value: 3 },
        { label: 'Dyslexia', value: 4 },
        { label: 'Math Difficulties', value: 5 },
        { label: 'Written Expression Problems', value: 6 },
        { label: 'Handwriting Problems', value: 7 },
        { label: 'Academic Underachievement', value: 8 },
        { label: 'Speech Problems', value: 9 },
        { label: 'Developmental Delays', value: 10 },

        { label: 'Intellectual Disability', value: 11 },
        { label: 'Motor Problems', value: 12 },
        { label: 'Childhood Behavioral Problems', value: 13 },
        { label: 'Tics (repetitive twitches, utterances)', value: 14 },
        { label: 'Obsessive-compulsive Behavior', value: 15 },
        { label: 'Anxiety Problems', value: 16 },
        { label: 'Depression', value: 17 },
        { label: 'Alcohol Abuse', value: 18 },
        { label: 'Drug Abuse', value: 19 },
        { label: 'Other Psychiatric Problems', value: 20 },
    ];

    const medicalProblemsValues: SelectObject[] = [
        { label: 'Convulsions/Seizures', value: 1 },
        { label: 'Migraine Headaches', value: 2 },
        { label: 'Brain Tumor', value: 3 },
        { label: 'Muscular Weakness', value: 4 },
        { label: 'Diabetes', value: 5 },
        { label: 'Thyroid Disease', value: 6 },
        { label: 'Heart Disease', value: 7 },
        { label: 'Hearing Impairment', value: 8 },
        { label: 'Visual Impairment', value: 9 },
        { label: 'Other', value: 10 },
    ];

    const behaviorsDisplayValues: SelectObject[] = [
        { label: 'Temper tantrums', value: 1 },
        { label: 'Aggressive behaviors', value: 2 },
        { label: 'Destructive behaviors', value: 3 },
        { label: 'Cruelty to animals', value: 4 },
        { label: 'Fire setting', value: 5 },
        { label: 'Lying', value: 6 },
        { label: 'Stealing', value: 7 },
        { label: 'Oppositional attitude/behavior', value: 8 },
        { label: 'Immaturity', value: 9 },
        { label: 'Social awkwardness', value: 10 },

        { label: 'Poor hygiene', value: 11 },
        { label: 'Poor social skills', value: 12 },
        { label: 'Shyness', value: 13 },
        { label: 'Anxiety', value: 14 },
        { label: 'Unusual fears', value: 15 },
        { label: 'Repetitive habits', value: 16 },
        { label: 'Unusual concerns', value: 17 },
        { label: 'Withdrawn', value: 18 },
        { label: 'Defiance', value: 19 },
        { label: 'Mood swings', value: 20 },
        { label: 'Drug/alcohol use', value: 21 },
        { label: 'Truancy from school', value: 22 },

        { label: 'Trouble with neighbors', value: 23 },
        { label: 'Excessive sadness', value: 24 },
        { label: 'Self harm (hitting or cutting themselves)', value: 25 },
        { label: 'Suicidal thinking or behavior (talking/writing.drawing about dying)', value: 26 },
        { label: 'Stubborn', value: 27 },
        { label: 'Separation fears/anxiety', value: 28 },
        { label: 'Eating problems', value: 29 },
        { label: 'Overly compliant', value: 30 },
        { label: 'Other', value: 31 },
    ];

    const behaviorsConcernToYouValues: SelectObject[] = [
        { label: 'Short attention span', value: 1 },
        { label: 'Problems concentrating', value: 2 },
        { label: 'Easily distracted', value: 3 },
        { label: 'Frequently off-task', value: 4 },
        { label: 'Impulsive', value: 5 },
        { label: 'Restless', value: 6 },
        { label: 'Hyperactive', value: 7 },
        { label: 'Disorganized', value: 8 },
        { label: 'Has difficulty listening when spoken to', value: 9 },
        { label: 'Reading problems', value: 10 },
        { label: 'Math problems', value: 11 },
        { label: 'Written expression problems', value: 12 },
        { label: 'Poor handwriting', value: 13 },
        { label: 'Poor spelling', value: 14 },
        { label: 'Poor physical coordination', value: 15 },
        { label: 'Difficulty verbally expressing self', value: 15 },
        { label: 'Difficulty adapting to change (e.g., rigid)', value: 16 },
        { label: 'Is forgetful', value: 17 },
        { label: 'Other', value: 18 },
    ];

    const receivedServicesValues: SelectObject[] = [
        { label: 'Early Intervention', value: 1 },
        { label: 'Speech/Language Therapy', value: 2 },
        { label: 'Occupational Therapy', value: 3 },
        { label: 'Physical Therapy', value: 4 },
        { label: 'Academic Resource Help', value: 5 },
        { label: 'Outside of School Tutoring', value: 6 },
        { label: 'Learning Disability Program', value: 7 },
        { label: 'Academic Enrichment Program', value: 8 },
        { label: 'School-based counseling', value: 9 },
        { label: 'Outside of school counseling', value: 10 },
        { label: 'Other', value: 11 },
    ];

    return (
        <form onSubmit={handleSubmit} className={classNames(styles.form)}>
            <h2>Testing Intake Questionnaire: Child/Adolescent</h2>
            <div>Please fill out the following questions to the best of your ability.</div>
            <FormError error={error} />
            <FieldInput
                name="student"
                type="hidden"
                wrapperConfig={{
                    label: '',
                }}
            />
            <FieldInput
                name="formId"
                type="hidden"
                value={6}
                wrapperConfig={{
                    label: '',
                }}
            />

            <FieldInput
                name="childName"
                type="text"
                validate={validators.childName}
                wrapperConfig={{
                    label: "Child's name: *",
                }}
            />
            <FieldDate
                name="childDob"
                type="text"
                date={true}
                validate={validators.childDob}
                wrapperConfig={{
                    label: "Child's date of birth: *",
                }}
            />
            <FieldInput
                name="childHeight"
                type="text"
                validate={validators.childHeight}
                wrapperConfig={{
                    label: 'Child height and approximate weight: *',
                }}
            />
            <FieldInput
                name="childHanded"
                type="text"
                validate={validators.childHanded}
                wrapperConfig={{
                    label: 'Child left or right handed: *',
                }}
            />
            <FieldInput
                name="childFeatured"
                type="text"
                validate={validators.childFeatured}
                wrapperConfig={{
                    label: 'Child identifying features (hair,eye color): *',
                }}
            />
            <FieldInput
                name="ethnicity"
                type="text"
                validate={validators.ethnicity}
                wrapperConfig={{
                    label: 'Race/Ethnicity: *',
                }}
            />
            <FieldInput
                name="gradeSchool"
                type="text"
                validate={validators.gradeSchool}
                wrapperConfig={{
                    label: 'School and Grade: *',
                }}
            />
            <FieldInput
                name="nameOfSchool"
                type="text"
                validate={validators.nameOfSchool}
                wrapperConfig={{
                    label: 'Classroom Teacher (name and contact information): *',
                }}
            />
            <FieldInput
                name="haveIep"
                type="text"
                validate={validators.haveIep}
                wrapperConfig={{
                    label: 'Does your child have an IEP? If so, why?: *',
                }}
            />

            <FieldInput
                name="parentFirstName"
                type="text"
                validate={validators.parentFirstName}
                wrapperConfig={{
                    label: "Guardian 1's name and relationship: *",
                }}
            />
            <FieldDate
                name="parentFirstDob"
                type="text"
                date={true}
                validate={validators.parentFirstDob}
                wrapperConfig={{
                    label: "Guardian 1's date of birth: *",
                }}
            />
            <FieldInput
                name="parentFirstHomePhone"
                type="text"
                validate={validators.parentFirstHomePhone}
                wrapperConfig={{
                    label: "Guardian 1's telephone number: *",
                }}
            />
            <FieldInput
                name="parentFirstHome"
                type="text"
                validate={validators.parentFirstHome}
                wrapperConfig={{
                    label: 'Home: *',
                }}
            />
            <FieldInput
                name="parentFirstCell"
                type="text"
                validate={validators.parentFirstCell}
                wrapperConfig={{
                    label: 'Cell: *',
                }}
            />
            <FieldInput
                name="parentFirstWorkPhone"
                type="text"
                validate={validators.parentFirstWorkPhone}
                wrapperConfig={{
                    label: 'Work: *',
                }}
            />
            <FieldInput
                name="parentFirstEmail"
                type="text"
                validate={validators.parentFirstEmail}
                wrapperConfig={{
                    label: "Guardian 1's email address: *",
                }}
            />
            <FieldInput
                name="parentFirstAddress"
                type="text"
                validate={validators.parentFirstAddress}
                wrapperConfig={{
                    label: "Guardian 1's home address: *",
                }}
            />
            <FieldInput
                name="parentFirstHighLevelOfEdu"
                type="text"
                validate={validators.parentFirstHighLevelOfEdu}
                wrapperConfig={{
                    label: "Guardian 1's highest level of education: *",
                }}
            />
            <FieldInput
                name="parentFirstPlaceOfEmployment"
                type="text"
                validate={validators.parentFirstPlaceOfEmployment}
                wrapperConfig={{
                    label: "Guardian 1's place of employment: *",
                }}
            />
            <FieldInput
                name="parentFirstPositionAtWork"
                type="text"
                validate={validators.parentFirstPositionAtWork}
                wrapperConfig={{
                    label: "Guardian 1's position at work: *",
                }}
            />
            <label htmlFor="parentFirstIsCall">Is it okay to call?: *</label>
            <FieldSelectList
                multiple={false}
                name="parentFirstIsCall"
                data={yesNoValues}
                validate={validators.parentFirstIsCall}
                textField={'label'}
                valueField={'value'}
            />

            <FieldInput
                name="parentFirstCallHours"
                type="text"
                validate={validators.parentFirstCallHours}
                wrapperConfig={{
                    label: 'Guardian 1 prefers to be contacted during these hours: *',
                }}
            />

            <FieldInput
                name="parentSecondName"
                type="text"
                validate={validators.parentSecondName}
                wrapperConfig={{
                    label: "Guardian 2's name and relationship: *",
                }}
            />
            <FieldDate
                name="parentSecondDob"
                type="text"
                date={true}
                validate={validators.parentSecondDob}
                wrapperConfig={{
                    label: "Guardian 2's date of birth: *",
                }}
            />
            <FieldInput
                name="parentSecondHomePhone"
                type="text"
                validate={validators.parentSecondHomePhone}
                wrapperConfig={{
                    label: "Guardian 2's telephone number: *",
                }}
            />
            <FieldInput
                name="parentSecondHome"
                type="text"
                validate={validators.parentSecondHome}
                wrapperConfig={{
                    label: 'Home: *',
                }}
            />
            <FieldInput
                name="parentSecondCell"
                type="text"
                validate={validators.parentSecondCell}
                wrapperConfig={{
                    label: 'Cell: *',
                }}
            />
            <FieldInput
                name="parentSecondWorkPhone"
                type="text"
                validate={validators.parentSecondWorkPhone}
                wrapperConfig={{
                    label: 'Work: *',
                }}
            />

            <FieldInput
                name="parentSecondEmail"
                type="text"
                validate={validators.parentSecondEmail}
                wrapperConfig={{
                    label: "Guardian 2's email address: *",
                }}
            />
            <FieldInput
                name="parentSecondAddress"
                type="text"
                validate={validators.parentSecondAddress}
                wrapperConfig={{
                    label: "Guardian 2's home address: *",
                }}
            />
            <FieldInput
                name="parentSecondHighLevelOfEdu"
                type="text"
                validate={validators.parentSecondHighLevelOfEdu}
                wrapperConfig={{
                    label: "Guardian 2's highest level of education: *",
                }}
            />
            <FieldInput
                name="parentSecondPlaceOfEmployment"
                type="text"
                validate={validators.parentSecondPlaceOfEmployment}
                wrapperConfig={{
                    label: "Guardian 2'd place of employment: *",
                }}
            />
            <FieldInput
                name="parentSecondPositionAtWork"
                type="text"
                validate={validators.parentSecondPositionAtWork}
                wrapperConfig={{
                    label: "Guardian 2's position at work: *",
                }}
            />

            <label htmlFor="parentSecondIsCall">Is it okay to call?: *</label>
            <FieldSelectList
                multiple={false}
                name="parentSecondIsCall"
                data={yesNoValues}
                validate={validators.parentSecondIsCall}
                textField={'label'}
                valueField={'value'}
            />

            <FieldInput
                name="parentSecondCallHours"
                type="text"
                validate={validators.parentSecondCallHours}
                wrapperConfig={{
                    label: 'Guardian 2 prefers to be contacted during these hours: *',
                }}
            />

            <h3 className={classNames(styles.subTitle)}>Referral Information</h3>
            <div className={classNames(styles.fixNotice)}>
                Please fill out the following questions to the best of your ability.
            </div>

            <FieldTextArea
                name="refForEval"
                validate={validators.refForEval}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: 'Who referred you for the evaluation? Please list the name and organization: *',
                }}
            />
            <FieldTextArea
                name="concernsAboutChild"
                validate={validators.concernsAboutChild}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: 'What are your main concerns? Why is your child being evaluated?: *',
                }}
            />
            <FieldTextArea
                name="causingProblems"
                validate={validators.causingProblems}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: "What do you think is causing the child's problem(s)?: *",
                }}
            />
            <FieldTextArea
                name="problemsEvaluate"
                validate={validators.problemsEvaluate}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label:
                        'What questions would you like the evaluation to try to answer? (please be as detailed as possible): *',
                }}
            />

            <FieldTextArea
                name="stepsDealWithConcern"
                validate={validators.stepsDealWithConcern}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: 'To date, what steps have been taken to deal with the concerns?: *',
                }}
            />

            <FieldTextArea
                name="childStrengths"
                validate={validators.childStrengths}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: "What are the child's strength's?: *",
                }}
            />

            <FieldTextArea
                name="hasBeenEvaluated"
                validate={validators.hasBeenEvaluated}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label:
                        'Has your child been evaluated or tested previously? Please list dates and type of evaluation: *',
                }}
            />

            <FieldTextArea
                name="emailPdf"
                validate={validators.emailPdf}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: "Please email PDF's of previous evaluation reports: *",
                }}
            />

            <FieldTextArea
                name="evalOrTreatment"
                validate={validators.evalOrTreatment}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label:
                        'Has your child received talk therapy or counseling before? Please list dates and type of service (outpatient,\n' +
                        'inpatient, school counseling) and locations: *',
                }}
            />

            <FieldTextArea
                name="childStrengthsTwo"
                validate={validators.childStrengthsTwo}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: "What are the child's strengths?: *",
                }}
            />

            <h3 className={classNames(styles.subTitle)}>Pregnancy and Birth Information</h3>
            <div className={classNames(styles.fixNotice)}>
                Please fill out the following questions to the best of your ability.
            </div>

            <FieldTextArea
                name="bioChild"
                validate={validators.bioChild}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: 'My child is (birth order): *',
                }}
            />

            <FieldInput
                name="motherAge"
                type="text"
                validate={validators.motherAge}
                wrapperConfig={{
                    label: "Mother's age at time of delivery: *",
                }}
            />

            <FieldInput
                name="fatherAge"
                type="text"
                validate={validators.fatherAge}
                wrapperConfig={{
                    label: "Father's age at time of delivery: *",
                }}
            />

            <FieldInput
                name="numOfPreg"
                type="text"
                validate={validators.numOfPreg}
                wrapperConfig={{
                    label: 'What pregnancy was this?: *',
                }}
            />

            <FieldInput
                name="twinOrNotPreg"
                type="text"
                validate={validators.twinOrNotPreg}
                wrapperConfig={{
                    label: 'Was the product of a twin/multiple birth: *',
                }}
            />

            <FieldInput
                name="complicationsPreg"
                type="text"
                validate={validators.complicationsPreg}
                wrapperConfig={{
                    label: 'Any complications with the pregnancy?: *',
                }}
            />

            <FieldInput
                name="motherMiscarriages"
                type="text"
                validate={validators.motherMiscarriages}
                wrapperConfig={{
                    label: 'Mother had prior miscarriages: *',
                }}
            />

            <label htmlFor="conditionsRelatedPreg">
                Please check possible conditions related to pregnancy and delivery of the child (check all that apply):
            </label>
            <FieldSelectList
                multiple={true}
                name="conditionsRelatedPreg"
                data={conditionsRelatedPregValues}
                validate={validators.conditionsRelatedPreg}
                textField={'label'}
                valueField={'value'}
            />
            <FieldInput
                name="conditionRelatedPregOther"
                type="text"
                validate={validators.conditionRelatedPregOther}
                wrapperConfig={{
                    label: 'Any complications with the birth?:',
                }}
            />

            <label htmlFor="motherDuringPreg">
                Please check possible conditions related to pregnancy and delivery of the child (check all that apply):
            </label>
            <FieldSelectList
                multiple={true}
                name="motherDuringPreg"
                data={motherDuringPregValues}
                validate={validators.motherDuringPreg}
                textField={'label'}
                valueField={'value'}
            />

            <FieldTextArea
                name="deliveryDifficult"
                validate={validators.deliveryDifficult}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: 'Was delivery difficult: *',
                }}
            />

            <FieldTextArea
                name="byCesareanSection"
                validate={validators.byCesareanSection}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: 'Was child delivered by Caesarean: *',
                }}
            />
            <FieldInput
                name="laborLast"
                type="text"
                validate={validators.laborLast}
                wrapperConfig={{
                    label: 'How many hours did labor last?: *',
                }}
            />
            <FieldTextArea
                name="nicuWas"
                validate={validators.nicuWas}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: 'Did your child spend any time in the NICU? If so, why?: *',
                }}
            />
            <FieldTextArea
                name="fullTerm"
                validate={validators.fullTerm}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: 'Was your child born full-term (38 weeks)? If not, please list number of weeks: *',
                }}
            />
            <FieldInput
                name="hospitalBorn"
                type="text"
                validate={validators.hospitalBorn}
                wrapperConfig={{
                    label: 'Name and location of hospital where child was born: *',
                }}
            />
            <FieldTextArea
                name="childSeizures"
                validate={validators.childSeizures}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: 'Child experienced seizures? If yes, describe type, frequency and treatment: *',
                }}
            />
            <FieldTextArea
                name="childInfection"
                validate={validators.childInfection}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: 'Child had an infection? If yes, describe type, frequency and treatment: *',
                }}
            />
            <FieldTextArea
                name="childDefects"
                validate={validators.childDefects}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: 'Child was born with birth defects? If checked, describe type and treatment (if any): *',
                }}
            />
            <FieldTextArea
                name="childColic"
                validate={validators.childColic}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: 'Child had colic? If checked, how long did it last?: *',
                }}
            />
            <FieldTextArea
                name="childAnyProblem"
                validate={validators.childAnyProblem}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: 'Describe other problems in infancy the child experienced: *',
                }}
            />

            <h3 className={classNames(styles.subTitle)}>Development</h3>
            <div className={classNames(styles.fixNotice)}>
                Please fill out the following questions to the best of your ability.
            </div>

            <FieldInput
                name="sitAge"
                type="text"
                validate={validators.sitAge}
                wrapperConfig={{
                    label: 'At what age was the child able to sit without help?: *',
                }}
            />

            <FieldInput
                name="walkAlone"
                type="text"
                validate={validators.walkAlone}
                wrapperConfig={{
                    label: 'Walk alone?: *',
                }}
            />

            <FieldInput
                name="jumpRun"
                type="text"
                validate={validators.jumpRun}
                wrapperConfig={{
                    label: 'Jump and run: *',
                }}
            />

            <FieldInput
                name="rideTwoWheelBike"
                type="text"
                validate={validators.rideTwoWheelBike}
                wrapperConfig={{
                    label: 'Ride a 2-wheel bike?: *',
                }}
            />

            <FieldInput
                name="useSpoon"
                type="text"
                validate={validators.useSpoon}
                wrapperConfig={{
                    label: 'Feed self with a spoon?: *',
                }}
            />

            <FieldInput
                name="dressSelf"
                type="text"
                validate={validators.dressSelf}
                wrapperConfig={{
                    label: 'Start to dress self?: *',
                }}
            />

            <FieldInput
                name="catchBall"
                type="text"
                validate={validators.catchBall}
                wrapperConfig={{
                    label: 'Catch a ball?: *',
                }}
            />

            <FieldInput
                name="firstWords"
                type="text"
                validate={validators.firstWords}
                wrapperConfig={{
                    label: 'Speak first word (e.g. cat, ball, cup)?: *',
                }}
            />

            <FieldInput
                name="putTwoWordsTogether"
                type="text"
                validate={validators.putTwoWordsTogether}
                wrapperConfig={{
                    label: 'Put 2 words together (e.g. Want please, Bid dog)?: *',
                }}
            />

            <FieldInput
                name="twoWordsSentence"
                type="text"
                validate={validators.twoWordsSentence}
                wrapperConfig={{
                    label: 'Speak in 2-3 word sentences (e.g. Give to me, I want juice)?: *',
                }}
            />

            <FieldInput
                name="tieShoelaces"
                type="text"
                validate={validators.tieShoelaces}
                wrapperConfig={{
                    label: 'Tie own shoelaces?: *',
                }}
            />

            <FieldInput
                name="achieveDaytimeDryness"
                type="text"
                validate={validators.achieveDaytimeDryness}
                wrapperConfig={{
                    label: 'Achieved daytime dryness?: *',
                }}
            />

            <FieldInput
                name="separateFromParents"
                type="text"
                validate={validators.separateFromParents}
                wrapperConfig={{
                    label: 'Separate from parent easily?: *',
                }}
            />

            <FieldInput
                name="toiletTrained"
                type="text"
                validate={validators.toiletTrained}
                wrapperConfig={{
                    label: 'Fully toilet trained?: *',
                }}
            />

            <h3 className={classNames(styles.subTitle)}>Child's Medical History</h3>
            <div className={classNames(styles.fixNotice)}>
                Please fill out the following questions to the best of your ability.
            </div>

            <FieldTextArea
                name="primaryPhysician"
                validate={validators.primaryPhysician}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: "Child's primary care physician (name, address, phone, email): *",
                }}
            />

            <FieldTextArea
                name="everHospitalized"
                validate={validators.everHospitalized}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label:
                        'Has the child ever been hospitalized or seen in an emergency room? If yes, please describe: *',
                }}
            />

            <FieldTextArea
                name="currentMedications"
                validate={validators.currentMedications}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: 'List current medications the child is taking (with dose): *',
                }}
            />

            <FieldTextArea
                name="haveAllergies"
                validate={validators.haveAllergies}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: 'Does the child have allergies? If yes, list allergies and treatment (if any): *',
                }}
            />

            <FieldTextArea
                name="immunizations"
                validate={validators.immunizations}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: "Are the child's immunizations up to date?: *",
                }}
            />

            <FieldTextArea
                name="headInjuries"
                validate={validators.headInjuries}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: 'Does the child have a history of any head injuries, including during sporting events?: *',
                }}
            />

            <label htmlFor="everHadAny">Has the child ever had (check all that apply): </label>
            <FieldSelectList
                multiple={true}
                name="everHadAny"
                data={everHadAnyValues}
                validate={validators.everHadAny}
                textField={'label'}
                valueField={'value'}
            />
            <FieldInput
                name="everHadAnyOther"
                type="text"
                validate={validators.everHadAnyOther}
                wrapperConfig={{
                    label: 'Please give more details about other:',
                }}
            />
            <FieldTextArea
                name="everHadAnyAdditional"
                validate={validators.everHadAnyAdditional}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: 'If yes to any of the above, please provide age and additional other information:',
                }}
            />
            <FieldTextArea
                name="hadEeg"
                validate={validators.hadEeg}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: 'Has your child ever had an EEG, CT Scan, or an MRI of the head?: ',
                }}
            />

            <h3 className={classNames(styles.subTitle)}>Mental Health History</h3>
            <div className={classNames(styles.fixNotice)}>
                Please fill out the following questions to the best of your ability.
            </div>

            <FieldTextArea
                name="seenCounselor"
                validate={validators.seenCounselor}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: 'Has your child ever seen a counselor, therapist, psychologist or psychiatrist?: ',
                }}
            />

            <FieldTextArea
                name="provideDates"
                validate={validators.provideDates}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: 'If so, please provide the dates, name of provider, and contact information:',
                }}
            />

            <FieldTextArea
                name="mentalProfessional"
                validate={validators.mentalProfessional}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label:
                        'Why was your child referred to a mental health professional [counselor, therapist, psychologist or psychiatrist]?:',
                }}
            />

            <FieldTextArea
                name="psychiatricHospital"
                validate={validators.psychiatricHospital}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: 'Has your child ever been in a psychiatric hospital?:',
                }}
            />

            <FieldTextArea
                name="datesHospital"
                validate={validators.datesHospital}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: 'If so, please provide the dates, name of provider and contact information:',
                }}
            />

            <FieldTextArea
                name="takenPsychMeds"
                validate={validators.takenPsychMeds}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: 'Has your child ever taken psych meds/psychotropic medication?:',
                }}
            />

            <FieldTextArea
                name="provideMeds"
                validate={validators.provideMeds}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: 'If so, please provide the name, dates, and dose:',
                }}
            />

            <FieldTextArea
                name="selfHarm"
                validate={validators.selfHarm}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: 'Have you ever had concerns about your child and self-harm/suicide?:',
                }}
            />

            <h3 className={classNames(styles.subTitle)}>Sleep</h3>
            <div className={classNames(styles.fixNotice)}>
                Please fill out the following questions to the best of your ability.
            </div>

            <FieldInput
                name="putBedSchool"
                type="text"
                validate={validators.putBedSchool}
                wrapperConfig={{
                    label: 'What time does your child go to bed on school nights?: *',
                }}
            />
            <FieldInput
                name="putBedNoSchool"
                type="text"
                validate={validators.putBedNoSchool}
                wrapperConfig={{
                    label: 'What time does your child go to bed on non-school nights?: *',
                }}
            />
            <FieldInput
                name="wakeUpSchool"
                type="text"
                validate={validators.wakeUpSchool}
                wrapperConfig={{
                    label: 'What time does your child wake up on school mornings?: *',
                }}
            />
            <FieldInput
                name="wakeUpNoSchool"
                type="text"
                validate={validators.wakeUpNoSchool}
                wrapperConfig={{
                    label: 'What time does your child go to bed on non-school mornings?: *',
                }}
            />

            <label htmlFor="sleepProblems">
                Does your child have any of the following sleep issues? (check all that apply):
            </label>
            <FieldSelectList
                multiple={true}
                name="sleepProblems"
                data={sleepProblemsValues}
                validate={validators.sleepProblems}
                textField={'label'}
                valueField={'value'}
            />
            <FieldInput
                name="sleepProblemsOther"
                type="text"
                validate={validators.sleepProblemsOther}
                wrapperConfig={{
                    label: 'Please give more details about other:',
                }}
            />

            <h3 className={classNames(styles.subTitle)}>Family/Home Information</h3>
            <div className={classNames(styles.fixNotice)}>
                Please fill out the following questions to the best of your ability.
            </div>

            <FieldTextArea
                name="relativesList"
                validate={validators.relativesList}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: 'Who lives in the home with you and your child? Please list names and ages.: *',
                }}
            />

            <FieldTextArea
                name="immediateFamilyMembersList"
                validate={validators.immediateFamilyMembersList}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label:
                        'If any immediate family members (sibling, parent) live in another home, please list names and ages.: *',
                }}
            />

            <FieldTextArea
                name="areDivorced"
                validate={validators.areDivorced}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label:
                        'If parents are divorced or separated, please describe who holds custody of child and visitation arrangements.: *',
                }}
            />

            <FieldInput
                name="motherLegalCustody"
                type="text"
                validate={validators.motherLegalCustody}
                wrapperConfig={{
                    label: 'Mother has legal custody (decision making power): *',
                }}
            />
            <FieldInput
                name="motherPhysicalCustody"
                type="text"
                validate={validators.motherPhysicalCustody}
                wrapperConfig={{
                    label: 'Mother has physical custody (child lives with mother at least some time): *',
                }}
            />
            <FieldInput
                name="fatherLegalCustody"
                type="text"
                validate={validators.fatherLegalCustody}
                wrapperConfig={{
                    label: 'Father has legal custody (decision making power): *',
                }}
            />
            <FieldInput
                name="fatherPhysicalCustody"
                type="text"
                validate={validators.fatherPhysicalCustody}
                wrapperConfig={{
                    label: 'Father has physical custody (child lives with father at least some time): *',
                }}
            />
            <FieldInput
                name="parentsCustody"
                type="text"
                validate={validators.parentsCustody}
                wrapperConfig={{
                    label: 'Parents have a custody order filed in a family court.: *',
                }}
            />
            <FieldInput
                name="residingAnotherHome"
                type="text"
                validate={validators.residingAnotherHome}
                wrapperConfig={{
                    label:
                        'Is child in foster care or residing in another home other than with immediate family (parents, siblings)?: *',
                }}
            />

            <FieldInput
                name="spokenLang"
                type="text"
                validate={validators.spokenLang}
                wrapperConfig={{
                    label: 'Child’s primary language: *',
                }}
            />
            <FieldInput
                name="spokenLangTwo"
                type="text"
                validate={validators.spokenLangTwo}
                wrapperConfig={{
                    label: 'Child’s secondary language: *',
                }}
            />
            <FieldInput
                name="parentPrimaryLang"
                type="text"
                validate={validators.parentPrimaryLang}
                wrapperConfig={{
                    label: 'Parent primary language: *',
                }}
            />
            <FieldInput
                name="parentSecondaryLang"
                type="text"
                validate={validators.parentSecondaryLang}
                wrapperConfig={{
                    label: 'Parent secondary language/s: *',
                }}
            />

            <label htmlFor="relatedProblems">
                Has your child or your family experienced any other of the following events during the child's
                lifetime?:
            </label>
            <FieldSelectList
                multiple={true}
                name="relatedProblems"
                data={relatedProblemsValues}
                validate={validators.relatedProblems}
                textField={'label'}
                valueField={'value'}
            />

            <h3 className={classNames(styles.subTitle)}>Family Psychological History</h3>
            <div className={classNames(styles.fixNotice)}>
                Please fill out the following questions to the best of your ability.
            </div>

            <FieldTextArea
                name="historyOfAnyFollowing"
                validate={validators.historyOfAnyFollowing}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: 'Is there a history of any of the following? If yes, list name, relation, and age.: *',
                }}
            />

            <label htmlFor="psychologicalProblems">
                Listed below are a number of different medical, psychological and learning problems. Place a check by
                those problems a family member (other than the child who is being referred for evaluation treatment) has
                experienced.:
            </label>
            <FieldSelectList
                multiple={true}
                name="psychologicalProblems"
                data={psychologicalProblemsValues}
                validate={validators.psychologicalProblems}
                textField={'label'}
                valueField={'value'}
            />

            <h3 className={classNames(styles.subTitle)}>Family Medical History</h3>
            <div className={classNames(styles.fixNotice)}>
                Please fill out the following questions to the best of your ability.
            </div>

            <label htmlFor="medicalProblems">
                Is there a history of any of the following? If yes, list name, relation, and age.:
            </label>
            <FieldSelectList
                multiple={true}
                name="medicalProblems"
                data={medicalProblemsValues}
                validate={validators.medicalProblems}
                textField={'label'}
                valueField={'value'}
            />

            <FieldTextArea
                name="indicateRelation"
                validate={validators.indicateRelation}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label:
                        "If you checked any of the above, please indicate the family member's relationship to the child (e.g. mother, father,\n" +
                        'sibling, aunt, uncle, cousin, grandmother, etc). Also, please indicate M for maternal family relatives or P for parental\n' +
                        'family: *',
                }}
            />

            <h3 className={classNames(styles.subTitle)}>Child's Relationships to Others and Behaviors</h3>
            <div className={classNames(styles.fixNotice)}>
                Please fill out the following questions to the best of your ability.
            </div>

            <FieldTextArea
                name="childAloneMother"
                validate={validators.childAloneMother}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: 'Describe how the child gets along with his or her: Mother: *',
                }}
            />

            <FieldTextArea
                name="childAloneFather"
                validate={validators.childAloneFather}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: 'Describe how the child gets along with his or her: Father: *',
                }}
            />

            <FieldTextArea
                name="childAloneSibling"
                validate={validators.childAloneSibling}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: 'Describe how the child gets along with his or her: Sibling(s): *',
                }}
            />

            <FieldTextArea
                name="childAloneOtherRel"
                validate={validators.childAloneOtherRel}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: 'Describe how the child gets along with his or her: Other family members: *',
                }}
            />

            <FieldTextArea
                name="childAloneWithBoys"
                validate={validators.childAloneWithBoys}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: 'Describe how the child gets along outside of school with: Boys his/her own age: *',
                }}
            />

            <FieldTextArea
                name="childAloneWithGirls"
                validate={validators.childAloneWithGirls}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: 'Describe how the child gets along outside of school with: Girls his/her own age: *',
                }}
            />

            <FieldTextArea
                name="childAloneWithYounger"
                validate={validators.childAloneWithYounger}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: 'Describe how the child gets along outside of school with: Younger children: *',
                }}
            />

            <FieldTextArea
                name="childAloneWithAdult"
                validate={validators.childAloneWithAdult}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: 'Describe how the child gets along outside of school with: Adults: *',
                }}
            />

            <FieldTextArea
                name="temperament"
                validate={validators.temperament}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: "Please describe the child's temperament and personality: *",
                }}
            />

            <FieldTextArea
                name="manageDiscipline"
                validate={validators.manageDiscipline}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: 'Who in the family usually manages/disciplines the child?: *',
                }}
            />

            <FieldTextArea
                name="methodDiscipline"
                validate={validators.methodDiscipline}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label:
                        'What have you found to be useful methods for managing/disciplining the child (e.g. using rewards, taking away\n' +
                        'privileges, isolation, time out, spanking, etc.)?: *',
                }}
            />

            <label htmlFor="behaviorsDisplay">Please check any of the following behaviors the child displays: </label>
            <FieldSelectList
                multiple={true}
                name="behaviorsDisplay"
                data={behaviorsDisplayValues}
                validate={validators.behaviorsDisplay}
                textField={'label'}
                valueField={'value'}
            />
            <FieldInput
                name="behaviorsDisplayOther"
                type="text"
                validate={validators.behaviorsDisplayOther}
                wrapperConfig={{
                    label: 'Please give more details about other:',
                }}
            />

            <label htmlFor="behaviorsConcernToYou">
                Check any of these behaviors that are of concern to you about your child:
            </label>
            <FieldSelectList
                multiple={true}
                name="behaviorsConcernToYou"
                data={behaviorsConcernToYouValues}
                validate={validators.behaviorsConcernToYou}
                textField={'label'}
                valueField={'value'}
            />
            <FieldInput
                name="behaviorsConcernToYouOther"
                type="text"
                validate={validators.behaviorsConcernToYouOther}
                wrapperConfig={{
                    label: 'Please give more details about other:',
                }}
            />

            <h3 className={classNames(styles.subTitle)}>School Experiences</h3>
            <div className={classNames(styles.fixNotice)}>
                Please fill out the following questions to the best of your ability.
            </div>

            <FieldTextArea
                name="schoolInfo"
                validate={validators.schoolInfo}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: 'School information: *',
                }}
            />

            <FieldTextArea
                name="schoolName"
                validate={validators.schoolName}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: 'School name: *',
                }}
            />

            <FieldTextArea
                name="schoolLocation"
                validate={validators.schoolLocation}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: 'Location/address of school: *',
                }}
            />

            <FieldTextArea
                name="gradeOfChild"
                validate={validators.gradeOfChild}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: 'Current grade of child: *',
                }}
            />

            <FieldTextArea
                name="teacher"
                validate={validators.teacher}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: 'Name of teacher(s)/aide(s) best known to child: *',
                }}
            />

            <FieldTextArea
                name="childHaveIep"
                validate={validators.childHaveIep}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: 'Does your child currently have an IEP: *',
                }}
            />

            <FieldTextArea
                name="havePlan"
                validate={validators.havePlan}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: 'Does your child currently have a 504 plan?: *',
                }}
            />

            <FieldTextArea
                name="doingInSchool"
                validate={validators.doingInSchool}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: 'How is your child doing in school?: *',
                }}
            />

            <FieldTextArea
                name="concernSchoolYear"
                validate={validators.concernSchoolYear}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: 'Do you have any concerns about the school year or your child’s education?: *',
                }}
            />

            <label htmlFor="receivedServices">
                Has the child ever received or participated in any of the following services?:
            </label>
            <FieldSelectList
                multiple={true}
                name="receivedServices"
                data={receivedServicesValues}
                validate={validators.receivedServices}
                textField={'label'}
                valueField={'value'}
            />
            <FieldInput
                name="receivedServicesOther"
                type="text"
                validate={validators.receivedServicesOther}
                wrapperConfig={{
                    label: 'Please give more details about other:',
                }}
            />

            <FieldTextArea
                name="receivedServicesAdditional"
                validate={validators.receivedServicesAdditional}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label:
                        'If you checked any of the above, please provide grade(s) or age(s) at the time of involvement: *',
                }}
            />

            <FieldTextArea
                name="curTeacher"
                validate={validators.curTeacher}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: "Do you have any concerns about this year's teacher?: *",
                }}
            />

            <FieldTextArea
                name="homework"
                validate={validators.homework}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label:
                        'Please describe how the child manages his or her homework. How many hours a night does he/she spend completing assignments?: *',
                }}
            />

            <FieldTextArea
                name="farSchool"
                validate={validators.farSchool}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label: 'How far would you like the child to go in school?: *',
                }}
            />

            <FieldTextArea
                name="otherInfo"
                validate={validators.otherInfo}
                wrapperConfig={{
                    classes: {
                        label: 'fullSize',
                    },
                    label:
                        'If there is other information you would like to share, please feel free to add comments here:',
                }}
            />

            <h3 className={classNames(styles.subTitle)}>Completion</h3>
            <div className={classNames(styles.fixNotice)}>Please write your name and date below</div>

            <FieldInput
                name="completedBy"
                type="text"
                validate={validators.completedBy}
                wrapperConfig={{
                    label: 'This form was completed by: *',
                }}
            />

            <FieldInput
                name="relationToChild"
                type="text"
                validate={validators.relationToChild}
                wrapperConfig={{
                    label: 'My relationship to the child: *',
                }}
            />

            <FieldDate
                name="completedDate"
                type="text"
                date={true}
                validate={validators.completedDate}
                wrapperConfig={{
                    label: 'Date form completed: *',
                }}
            />

            <FieldInput
                name="signPerson"
                type="text"
                validate={validators.signPerson}
                wrapperConfig={{
                    label: 'Signature of person completing the form: *',
                }}
            />

            <div className={classNames(styles.actions)}>
                <button
                    type="submit"
                    className={classNames('btn', 'btn-success', 'mr-3')}
                    disabled={!dirty || submitting}
                >
                    <FontAwesomeIcon icon={faSave} /> Confirm and Send
                </button>
            </div>
        </form>
    );
};

export default reduxForm<NeuropsychologyPatientFormData, NeuropsychologyPatientFormProps>({
    form: 'neuropsychology-patient-form-form',
    enableReinitialize: true,
    onSubmit: async (
        data: NeuropsychologyPatientFormData,
        dispatch: Dispatch<any>,
        props: NeuropsychologyPatientFormProps,
    ) => {
        props.setIsLoader(true);
        await asyncPersistIntakeNeuropsychologyPatient({ ...data }, dispatch);
    },
    onSubmitSuccess(
        result: any,
        dispatch: Dispatch<any>,
        props: DecoratedFormProps<NeuropsychologyPatientFormData, NeuropsychologyPatientFormProps, string>,
    ) {
        props.setIsLoader(false);
        //toast.success(`The form was successfully sent.`);
        dispatch(push(Router.generate(routes.INTAKE_PARENT_FORM_SUCCESS, {})));
    },
    onSubmitFail(errors: any) {
        // props.setIsLoader(false);
        if (errors) {
            let field: any = null;
            Object.keys(errors).map((e: any, index: number, array: any) => {
                if (!field) {
                    field = e;
                    return;
                }
                return;
            });
            if (field) {
                const section = document.querySelector(`label[for='${field}']`);
                section?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }
        if (errors._error) {
            toast.error(errors._error);
        }
    },
})(NeuropsychologyPatientForm);
